"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BinaryReader = void 0;
class BinaryReader {
    buffer;
    view;
    offset = 0;
    constructor(buffer) {
        this.buffer = buffer;
        this.view = new DataView(buffer.buffer, buffer.byteOffset, buffer.byteLength);
    }
    get position() {
        return this.offset;
    }
    set position(value) {
        if (value < 0 || value > this.buffer.length) {
            throw new RangeError(`Reader position out of bounds: ${value}`);
        }
        this.offset = value;
    }
    readUint8() {
        const value = this.view.getUint8(this.offset);
        this.offset += 1;
        return value;
    }
    readUint16LE() {
        const value = this.view.getUint16(this.offset, true);
        this.offset += 2;
        return value;
    }
    readUint32LE() {
        const value = this.view.getUint32(this.offset, true);
        this.offset += 4;
        return value;
    }
    readBytes(length) {
        if (this.offset + length > this.buffer.length) {
            throw new RangeError("Reader out of bounds");
        }
        const bytes = this.buffer.slice(this.offset, this.offset + length);
        this.offset += length;
        return bytes;
    }
    readString(offset, length) {
        if (offset < 0 || offset + length > this.buffer.length) {
            throw new RangeError("String read out of bounds");
        }
        return this.buffer.slice(offset, offset + length);
    }
}
exports.BinaryReader = BinaryReader;
//# sourceMappingURL=reader.js.map